export class PartialPlant {
  address1: string;
  colorId: number;
  color: string;
  divisionId: number;
  id: number;
  inactiveFlag: boolean;
  latitude: string;
  longitude: string;
  name: string;
  printTicketMethod: number;
  systemType: number;
  useBatchPanelFlag: boolean;
  // for settings
  selected?: boolean;
  visible?: boolean;
  divisionAbbreviation?: string;
}
